import { ArbManifest } from "@amzn/arb-tools";
import { LocalizationContextBuilder } from "@amzn/i18n.localization-context";
import { MbmProvider, useLocalizationContext } from "@amzn/react-arb-tools";
import { Locales, useLocale } from "@amzn/xb-hooks";
import { ReactNode, useEffect } from "react";

const localizationContextBuilder = new LocalizationContextBuilder().withDefaultLocale(Locales.ENGLISH.code);

export const LocalizationUpdater = ({ children }: { children: ReactNode }) => {
  const { locale, isLoading } = useLocale();
  const { localizationContext, setLocalizationContext } = useLocalizationContext();

  // Why do I need a useEffect here? (https://react.dev/learn/you-might-not-need-an-effect)
  // Calling a state setter from another component during the render of another component
  // is not allowed. We therefore have to do it after render, that is to say in an effect.
  useEffect(() => {
    if (!isLoading && locale?.code && localizationContext?.getLocale() !== Locales.arbLanguageCodeFor(locale)) {
      setLocalizationContext(localizationContextBuilder.withLocale(Locales.arbLanguageCodeFor(locale)).build());
    }
  }, [locale, isLoading, localizationContext, setLocalizationContext]);

  return <>{children}</>;
};

export const LocalizationProvider = ({
  children,
  arbManifest,
  resolveResourcePack,
}: {
  children: ReactNode;
  arbManifest: ArbManifest;
  resolveResourcePack: (url?: string) => Promise<any>;
}) => {
  const options = {
    arbManifest,
    defaultLocalizationContext: localizationContextBuilder.build(),
    resolveResourcePack,
  };

  return (
    <MbmProvider {...options}>
      <LocalizationUpdater>{children}</LocalizationUpdater>
    </MbmProvider>
  );
};
